export default {
  meta: {
    title: "PixelHaha {'|'} 無料でダウンロードできるストック画像",
    description:
      "さまざまな魅力的な画像をご覧ください。風景から抽象芸術まで、すべての画像は無料で、デザインのアイデアやソーシャル メディアのグラフィックを充実させるのに最適です。",
    keywords: "無料、ストック、ギャラリー、テキストから画像、AI生成",
    searchTitle:
      "「PixelHaha {'|'} {number}+ ベスト {keyword} · 100% 無料ダウンロード」",
    searchDescription:
      "「完璧な {keyword} 画像をダウンロードしてください。{number}+ を超える最高の無料 {keyword} 画像を見つけてください。商用利用は無料です。帰属表示は不要です。著作権フリーです。」",
    404: "エラー 404 - PixelHaha",
  },
};
